<div class="early-pay-calculator-page-wrapper">
  @if (!isSc) {
    <div class="early-pay-calculator-page-header">
      <a
        mat-button
        class="early-pay-calculator-page-header-back-link"
        routerLink="/early-pay/subscription"
      >
        <mat-icon class="early-pay-calculator-page-header-back-link-icon">keyboard_arrow_left</mat-icon>
        Back
      </a>
    </div>
  }
  <div
    class="epp-calculator-title"
    [class.early-pay-calculator-page-sc-top-padding]="isSc"
  >
    Early Pay calculator
  </div>

  <app-early-pay-calculator />
</div>
